import { useState, useEffect } from 'react'
import Image from 'next/image'
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos'
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos'
import { Navigation } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/css'
import styled from '@emotion/styled'

const modules = [Navigation]

const StyledSwiper = styled(Swiper)`
  ${({ theme }) => `
    .photo-swiper-prev, .photo-swiper-next {
      display: none;
    }

    ${theme.breakpoints.up('lg')} {
      &.swiper,
      &.swiper > .swiper-wrapper,
      &.swiper > .swiper-wrapper > .swiper-slide {
        height: 100%;
      }

      .photo-swiper-prev, .photo-swiper-next {
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        top: calc(50% - 18px);
        width: 36px;
        height: 36px;
        background: rgba(240, 240, 240, 0.8);
        border-radius: 50%;
        cursor: pointer;
        z-index: 1;

        > .MuiSvgIcon-root {
          font-size: 1rem;
        }
      }
      .photo-swiper-prev {
        left: 24px;
        padding-left: 6px;
      }
      .photo-swiper-next {
        right: 24px;
        padding-left: 2px;
      }

    }
  `}
`

const ImgRect = styled.div`
  ${({ theme }) => `
    position: relative;
    padding-top: 75%;

    ${theme.breakpoints.up('lg')} {
      padding-top: unset;
      height: 100%;
    }
  `}
`
const Absolute = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
`

const ImgWrapper = styled.div`
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;
  object-fit: contain;
`

const swiperNavigation = {
  nextEl: '.photo-swiper-next',
  prevEl: '.photo-swiper-prev',
}

const PhotoCarousel = ({
  photos,
  photoUrlId,
  setPhotoUrlId,
  frontCoverUrlId,
}) => {
  const [swiper, setSwiper] = useState(null)
  const [frontCoverIndex, setFrontCoverIndex] = useState(0)

  useEffect(() => {
    const frontCoverIndex = photos?.findIndex(
      (photo) => photo.urlId === frontCoverUrlId
    )
    if (frontCoverIndex > -1) {
      setFrontCoverIndex(frontCoverIndex)
    }
  }, [photos, frontCoverUrlId])

  useEffect(() => {
    if (!swiper) {
      return
    }
    const index = photos?.findIndex((photo) => photo.urlId === photoUrlId)
    if (index > -1 && swiper?.realIndex !== index) {
      swiper.slideTo(index)
    }
  }, [photos, photoUrlId, swiper])

  const onIndexChange = (swiper) => {
    const index = swiper.realIndex
    const photo = index > -1 ? photos?.[index] : null
    if (photo && photo.urlId !== photoUrlId) {
      setPhotoUrlId(photo.urlId)
    }
  }

  return (
    <StyledSwiper
      modules={modules}
      slidesPerView="auto"
      loop={!!photos?.length}
      centeredSlides={true}
      navigation={!!photos?.length ? swiperNavigation : false}
      onAfterInit={(swiper) => setSwiper(swiper)}
      onRealIndexChange={onIndexChange}
    >
      {photos?.length > 1 && (
        <>
          <div className="photo-swiper-next">
            <ArrowForwardIosIcon fontSize="small" />
          </div>
          <div className="photo-swiper-prev">
            <ArrowBackIosIcon fontSize="small" />
          </div>
        </>
      )}

      {photos?.map((photo, index) => (
        <SwiperSlide key={photo._id}>
          <ImgRect>
            <Absolute>
              <ImgWrapper>
                <Image
                  src={photo?.image?.url}
                  alt={photo?.description}
                  style={{ objectFit: 'contain' }}
                  fill
                  priority={frontCoverIndex === index}
                  quality={60}
                />
              </ImgWrapper>
            </Absolute>
          </ImgRect>
        </SwiperSlide>
      ))}
    </StyledSwiper>
  )
}

PhotoCarousel.defaultProps = {
  photos: [],
}

export default PhotoCarousel
